const destinations = [
  {
    country: "The Bahamas",
    icon: "ri-sun-cloudy-line",
    tag: "Top Destination",
    desc: "The Bahamas is the closest international destination to Deerfield Beach — just a short flight from FLL or PBI, or a day cruise from Port Everglades. Ideal for weekend getaways, family vacations, and island hopping.",
    docs: "U.S. passport required. Validity must cover your stay.",
  },
  {
    country: "Mexico & Cancun",
    icon: "ri-sun-line",
    tag: "Popular",
    desc: "Cancun, Playa del Carmen, and Los Cabos are top choices for Deerfield Beach travelers seeking all-inclusive resorts, beaches, and nightlife. Direct flights from FLL make this an easy trip.",
    docs: "U.S. passport required. 6-month validity recommended.",
  },
  {
    country: "Jamaica & The Caribbean",
    icon: "ri-drop-line",
    tag: "Cruise Hub",
    desc: "Jamaica, the Dominican Republic, Puerto Rico, and the U.S. Virgin Islands are staples for Caribbean cruises departing Port Everglades and PortMiami. A passport is strongly recommended even for closed-loop itineraries.",
    docs: "U.S. passport required for most islands. Check cruise line policy.",
  },
  {
    country: "Canada",
    icon: "ri-snowflake-line",
    tag: "Business Travel",
    desc: "Toronto, Montreal, and Vancouver draw both leisure and business travelers from Deerfield Beach. Many Broward County professionals travel regularly to Canada for conferences and partnerships.",
    docs: "U.S. passport required for air travel. Enhanced driver's license accepted for land/sea.",
  },
  {
    country: "Europe",
    icon: "ri-ancient-gate-line",
    tag: "Summer Vacations",
    desc: "Italy, France, Spain, the UK, and Germany are popular summer destinations for Deerfield Beach families and couples. Most Schengen countries require 3+ months validity beyond your departure date.",
    docs: "U.S. passport required. Must be valid 3+ months past departure from Schengen area.",
  },
  {
    country: "Central & South America",
    icon: "ri-earth-line",
    tag: "Growing",
    desc: "Costa Rica, Colombia, Peru, and Brazil are increasingly popular with Deerfield Beach travelers. Adventure tourism, eco-lodges, and cultural exploration draw visitors year-round.",
    docs: "U.S. passport required. Check specific country validity requirements before booking.",
  },
];

export default function DeerfieldBeachDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Deerfield Beach Travelers Go
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From quick Caribbean escapes to European adventures, Deerfield Beach residents travel far and wide. Here's what you need to know about passport requirements for the most popular destinations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {destinations.map((d, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]">
                    <i className={`${d.icon} text-[#F6C344] text-base`}></i>
                  </div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{d.country}</h3>
                </div>
                <span className="text-xs font-semibold text-[#1A365D] bg-[#1A365D]/8 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                  {d.tag}
                </span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.desc}</p>
              <div className="flex items-start gap-2 text-xs text-gray-600 bg-white rounded-md px-3 py-2 border border-gray-100">
                <i className="ri-passport-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                <span>{d.docs}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}